module.exports = {"340171401":"天乐社区服务中心","340171402":"兴园社区服务中心","340171403":"蜀麓社区服务中心","340171404":"长宁社区服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340171.json
// module id = 1043
// module chunks = 0